import { Skeleton } from '@mui/material';
import { FC } from 'react';
import { LabeledSectionSkeleton } from '../labeled-section/labeled-section.skeleton';
import { NoteSignature, NoteText, NoteWrapper } from './notes-section.styles';

export const NotesSectionSkeleton: FC = () => {
  const NoteSkeleton = ({ textLength }: { textLength: number }) => {
    return (
      <NoteWrapper>
        <NoteText>
          <Skeleton variant="text" height={15} width={textLength} />
        </NoteText>
        <NoteSignature>
          <Skeleton variant="text" width={100} height={13} sx={{ marginRight: '6px' }} />
          <Skeleton variant="circular" width={6} height={6} sx={{ marginRight: '6px' }} />
          <Skeleton variant="text" width={100} height={13} />
        </NoteSignature>
      </NoteWrapper>
    );
  };

  return (
    <LabeledSectionSkeleton labelWidth={50} labelPlaceholderWidth={20}>
      <NoteSkeleton textLength={250} />
      <NoteSkeleton textLength={180} />
    </LabeledSectionSkeleton>
  );
};
